import _toConsumableArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
// Copyright 2017-2021 @polkadot/metadata authors & contributors
// SPDX-License-Identifier: Apache-2.0

/** @internal */
export function flattenUniq(list) {
  var flat = list.reduce(function (result, entry) {
    return result.concat(Array.isArray(entry) ? flattenUniq(entry) : entry);
  }, []);
  return _toConsumableArray(new Set(flat)).filter(function (value) {
    return value;
  }).sort();
}